import cx from "classnames"
import type React from "react"
import { PureComponent } from "react"

export type CardProps = {
  children?: React.ReactNode
  className?: string
  legacy?: boolean
  // Not used anymore, to remove in the next release
  flattened?: boolean
  responsive?: boolean
}

export const Card = ({
  children,
  className,
  legacy,
  responsive,
}: CardProps) => (
  <div
    className={cx("cobalt-Card", className, {
      "cobalt-Card--legacy": legacy,
      "cobalt-Card--responsive": responsive,
    })}
  >
    {children}
  </div>
)

export type CardSectionProps = {
  children: React.ReactNode
  className?: string
  tabBar?: boolean
  tight?: boolean
  subdued?: boolean
  /**
   * true or "soft"
   * @default false
   */
  divided?: boolean | string
}

export type CardSectionLinkProps = CardSectionProps & {
  href: React.AnchorHTMLAttributes<HTMLAnchorElement>["href"]
  target?: React.AnchorHTMLAttributes<HTMLAnchorElement>["target"]
  rel?: React.AnchorHTMLAttributes<HTMLAnchorElement>["rel"]
}

const getClasses = ({
  className = "",
  tabBar,
  tight,
  subdued,
  divided,
}: CardSectionProps) => {
  return cx(className, "cobalt-Card__Section", {
    "cobalt-Card__Section--tabBar": tabBar === true,
    "cobalt-Card__Section--tight": tight === true,
    "cobalt-Card__Section--subdued": subdued === true,
    "cobalt-Card__Section--divided": divided === true,
    "cobalt-Card__Section--dividedSoft": divided === "soft",
  })
}

const CardSectionLink = ({
  href,
  target,
  rel,
  ...baseProps
}: CardSectionLinkProps) => {
  return (
    <a
      className={getClasses(baseProps)}
      href={href}
      target={target}
      rel={target && !rel ? "noopener noreferrer" : rel}
    >
      {baseProps.children}
    </a>
  )
}
CardSectionLink.displayName = "CardSection.Link"

export class CardSection extends PureComponent<CardSectionProps, never> {
  static Link = CardSectionLink
  render() {
    return <div className={getClasses(this.props)}>{this.props.children}</div>
  }
}

Card.Section = CardSection

export default Card
